import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import './Terms.css';

const Terms = () => {
  const { language, t } = useLanguage();

  const termsContentRu = (
    <div className="terms-content">
      <h1 className="terms-main-title">ПОЛЬЗОВАТЕЛЬСКОЕ СОГЛАШЕНИЕ</h1>
      <p className="terms-date">Дата последней редакции: 16 марта 2026 года</p>
      
      <p className="terms-intro">
        Настоящий документ «Пользовательское соглашение» (далее — «Соглашение») представляет собой 
        предложение команды Cycling Virtual League (далее — «Администрация», «Мы») 
        заключить договор с любым физическим лицом (далее — «Пользователь», «Вы») на изложенных ниже 
        условиях Соглашения относительно использования сервиса Cycling Virtual League (далее — «Сервис»).
      </p>

      <section className="terms-section">
        <h2>1. ОБЩИЕ ПОЛОЖЕНИЯ</h2>
        <p>
          <strong>1.1.</strong> Использование вами Сервиса любым способом и в любой форме (включая, но не 
          ограничиваясь: посещение сайта https://cyclingvirtualleague.com, регистрация, участие в турнирах) 
          создает договор на условиях настоящего Соглашения.
        </p>
        <p>
          <strong>1.2.</strong> Воспользовавшись Сервисом, вы подтверждаете, что:
        </p>
        <ul>
          <li>ознакомились с условиями настоящего Соглашения в полном объеме до начала использования;</li>
          <li>принимаете все условия настоящего Соглашения без каких-либо изъятий и ограничений;</li>
          <li>обязуетесь их соблюдать или прекратить использование Сервиса.</li>
        </ul>
        <p>
          <strong>1.3.</strong> Администрация оставляет за собой право вносить изменения в настоящее Соглашение 
          без какого-либо специального уведомления. Новая редакция Соглашения вступает в силу с момента ее 
          размещения на Сайте https://cyclingvirtualleague.com. Продолжение использования Сервиса после внесения 
          изменений означает ваше согласие с ними.
        </p>
      </section>

      <section className="terms-section">
        <h2>2. ТЕРМИНЫ И ОПРЕДЕЛЕНИЯ</h2>
        <p>
          <strong>2.1. Сервис (Платформа)</strong> — комплекс программно-аппаратных систем, размещённых в сети 
          интернет по адресу https://cyclingvirtualleague.com, который позволяет Пользователям:
        </p>
        <ul>
          <li>получать информацию о виртуальном велоспорте;</li>
          <li>регистрироваться для участия в турнирах, проводимых на платформе Rouvy;</li>
          <li>отслеживать свои результаты и результаты других участников;</li>
          <li>взаимодействовать с другими Пользователями в рамках сообщества.</li>
        </ul>
        <p>
          <strong>2.2. Пользователь</strong> — физическое лицо, прошедшее процедуру регистрации на Сайте и 
          присоединившееся к настоящему Соглашению.
        </p>
        <p>
          <strong>2.3. Rouvy</strong> — сторонняя платформа для виртуального велоспорта (доступна по адресу 
          https://rouvy.com), используемая для проведения соревнований. Администрация не является разработчиком, 
          представителем или аффилированным лицом Rouvy.
        </p>
        <p>
          <strong>2.4. Турнир</strong> — спортивное мероприятие, организуемое Администрацией на трассах Rouvy, 
          с системой учета результатов и подведением итогов.
        </p>
        <p>
          <strong>2.5. User Content (Контент Пользователя)</strong> — любая информация, загружаемая Пользователем 
          в Сервис или передаваемая через него, включая данные, тексты, изображения, комментарии.
        </p>
      </section>

      <section className="terms-section">
        <h2>3. РЕГИСТРАЦИЯ И УЧЕТНАЯ ЗАПИСЬ</h2>
        <p>
          <strong>3.1.</strong> Использование функциональных возможностей Сервиса (участие в турнирах, доступ к 
          расширенной статистике) допускается только после прохождения Пользователем регистрации и авторизации.
        </p>
        <p>
          <strong>3.2.</strong> При регистрации Пользователь обязуется предоставить достоверную и актуальную 
          информацию. Администрация собирает и обрабатывает следующие идентификационные данные: логин, адрес 
          электронной почты, имя (по желанию), а также данные, получаемые от Rouvy в рамках OAuth2-авторизации 
          (идентификатор пользователя Rouvy, результаты заездов).
        </p>
        <p>
          <strong>3.3.</strong> Пользователь несет полную ответственность за сохранность своих данных для 
          авторизации (логин, пароль) и обязуется не передавать их третьим лицам. Администрация не несет 
          ответственности за любой ущерб, возникший в результате несанкционированного доступа к учетной 
          записи Пользователя.
        </p>
        <p>
          <strong>3.4.</strong> Пользователь обязуется использовать свои настоящие Имя и Фамилию при регистрации 
          и участии в турнирах. Использование ников, содержащих нецензурные или оскорбительные выражения, запрещено.
        </p>
        <p>
          <strong>3.5.</strong> Сервис может использоваться лицами, достигшими 13 лет. Для доступа к определенным 
          функциям, связанным со здоровьем и персональными данными, Пользователь должен быть не моложе 16 лет. 
          Если Пользователь младше установленного возраста, использование Сервиса допускается только с согласия 
          законного представителя.
        </p>
      </section>

      <section className="terms-section">
        <h2>4. ПРАВА И ОБЯЗАННОСТИ СТОРОН</h2>
        <p><strong>4.1. Пользователь имеет право:</strong></p>
        <ul>
          <li>получать доступ к Сервису и участвовать в Турнирах на условиях настоящего Соглашения;</li>
          <li>запрашивать информацию о своих результатах;</li>
          <li>требовать удаления своих персональных данных, направив запрос Администрации;</li>
          <li>деактивировать свою учетную запись в любое время.</li>
        </ul>
        <p><strong>4.2. Пользователь обязуется:</strong></p>
        <ul>
          <li>соблюдать правила участия в Турнирах;</li>
          <li>не использовать Сервис для размещения рекламы сторонних ресурсов без согласования с Администрацией;</li>
          <li>не публиковать материалы, пропагандирующие насилие, экстремизм, дискриминацию, содержащие 
            нецензурную лексику или оскорбления;</li>
          <li>не пытаться несанкционированно вмешиваться в работу Сервиса, не использовать автоматизированные 
            средства (роботы, пауки) для доступа к Сервису;</li>
          <li>не нарушать права интеллектуальной собственности Администрации или третьих лиц.</li>
        </ul>
        <p><strong>4.3. Администрация имеет право:</strong></p>
        <ul>
          <li>устанавливать лимиты, правила и регламенты проведения Турниров;</li>
          <li>изменять функциональность Сервиса, добавлять или удалять функции без предварительного уведомления;</li>
          <li>блокировать, приостанавливать или удалять учетную запись Пользователя в случае нарушения 
            настоящего Соглашения;</li>
          <li>удалять любой контент, размещенный Пользователем, если он нарушает условия Соглашения.</li>
        </ul>
        <p><strong>4.4. Администрация обязуется:</strong></p>
        <ul>
          <li>обеспечивать функционирование Сервиса в соответствии с его назначением;</li>
          <li>не передавать персональные данные Пользователей третьим лицам, за исключением случаев, 
            предусмотренных применимым законодательством.</li>
        </ul>
      </section>

      <section className="terms-section">
        <h2>5. УЧАСТИЕ В ТУРНИРАХ</h2>
        <p>
          <strong>5.1.</strong> Участие в Турнирах, проводимых в рамках Сервиса, является добровольным.
        </p>
        <p>
          <strong>5.2.</strong> Для участия в Турнире Пользователь должен:
        </p>
        <ul>
          <li>быть зарегистрированным на Сайте cyclingvirtualleague.com;</li>
          <li>иметь активную учетную запись на платформе Rouvy;</li>
          <li>пройти процедуру OAuth2-авторизации для предоставления Сервису доступа к необходимым данным 
            (результаты заездов).</li>
        </ul>
        <p>
          <strong>5.3.</strong> Пользователь может использовать сторонние аккаунты (Rouvy) для регистрации и 
          входа в Сервис. В таком случае Пользователь предоставляет Администрации согласие на доступ к данным 
          в таком стороннем аккаунте в соответствии с настройками приватности.
        </p>
        <p>
          <strong>5.4.</strong> Пользователь подтверждает, что участие в виртуальных велосипедных соревнованиях 
          требует определенного уровня физической подготовки. Администрация не несет ответственности за:
        </p>
        <ul>
          <li>любые травмы или ухудшение здоровья, полученные в процессе тренировок или участия в Турнирах;</li>
          <li>технические сбои на стороне платформы Rouvy или оборудования Пользователя.</li>
        </ul>
        <p>
          <strong>5.5.</strong> Результаты Турниров фиксируются автоматически платформой Rouvy. Администрация 
          осуществляет подсчет и публикацию итоговых результатов на Сайте, но не гарантирует абсолютную 
          точность данных, получаемых от сторонних платформ.
        </p>
      </section>

      <section className="terms-section">
        <h2>6. КОНТЕНТ И ИНТЕЛЛЕКТУАЛЬНАЯ СОБСТВЕННОСТЬ</h2>
        <p>
          <strong>6.1.</strong> Контент, размещенный на Сайте (дизайн, тексты, логотип «Cycling Virtual League»), 
          является интеллектуальной собственностью Администрации и защищен авторским правом.
        </p>
        <p>
          <strong>6.2.</strong> Пользователь сохраняет все права на контент, который он загружает в Сервис. 
          Размещая контент, Пользователь предоставляет Администрации безвозмездную, неисключительную лицензию 
          на использование, воспроизведение и отображение такого контента в связи с функционированием Сервиса.
        </p>
        <p>
          <strong>6.3.</strong> Использование контента с Сайта в коммерческих целях без письменного согласия 
          Администрации запрещено.
        </p>
        <p>
          <strong>6.4.</strong> Сервис Cycling Virtual League не имеет аффилиации, спонсорской поддержки или 
          связи с торговыми марками третьих лиц, упоминаемыми на платформе. Любое использование названий, 
          товарных знаков или логотипов осуществляется исключительно в информационных целях для идентификации.
        </p>
      </section>

      <section className="terms-section">
        <h2>7. ОТКАЗ ОТ ГАРАНТИЙ И ОГРАНИЧЕНИЕ ОТВЕТСТВЕННОСТИ</h2>
        <p>
          <strong>7.1.</strong> Сервис предоставляется на условиях «как есть» (as-is) и «по мере доступности» 
          (as available). Администрация не гарантирует бесперебойную работу Сервиса или отсутствие ошибок.
        </p>
        <p>
          <strong>7.2.</strong> Администрация не гарантирует, что информация, отображаемая в Сервисе (особенно 
          получаемая от третьих лиц), будет полной, точной или актуальной.
        </p>
        <p>
          <strong>7.3.</strong> Ни при каких обстоятельствах Администрация не несет ответственности за любые 
          прямые, косвенные, случайные убытки, возникшие в результате использования или невозможности 
          использования Сервиса.
        </p>
      </section>

      <section className="terms-section">
        <h2>8. ПРЕКРАЩЕНИЕ ДЕЙСТВИЯ АККАУНТА</h2>
        <p>
          <strong>8.1.</strong> Пользователь может деактивировать свою учетную запись в любое время через 
          настройки профиля.
        </p>
        <p>
          <strong>8.2.</strong> При деактивации учетной записи весь контент Пользователя может быть удален, 
          а доступ к Сервису прекращен.
        </p>
        <p>
          <strong>8.3.</strong> Администрация может деактивировать учетную запись при длительном отсутствии 
          активности (более 24 месяцев), уведомив Пользователя по электронной почте.
        </p>
      </section>

      <section className="terms-section">
        <h2>9. ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ</h2>
        <p>
          <strong>9.1.</strong> Настоящее Соглашение вступает в силу для Пользователя с момента регистрации 
          на Сайте и действует в течение всего периода использования Сервиса.
        </p>
        <p>
          <strong>9.2.</strong> Пользователь соглашается на получение информационных и рекламных сообщений от 
          Администрации, связанных с функционированием Сервиса. Пользователь имеет право отказаться от получения 
          рассылки в настройках профиля.
        </p>
        <p>
          <strong>9.3.</strong> Настоящее Соглашение регулируется законодательством по месту регистрации Администрации. 
          Все споры подлежат разрешению в суде по месту регистрации Администрации.
        </p>
      </section>
    </div>
  );

  const termsContentEn = (
    <div className="terms-content">
      <h1 className="terms-main-title">TERMS OF SERVICE</h1>
      <p className="terms-date">Last updated: March 16, 2026</p>
      
      <p className="terms-intro">
        This document "Terms of Service" (hereinafter referred to as the "Agreement") is an offer from 
        the website team Cycling Virtual League (hereinafter referred to as "Administration", "We") 
        to enter into an agreement with any individual (hereinafter referred to as "User", "You") on the terms 
        set forth below regarding the use of the Cycling Virtual League service (hereinafter referred to as the "Service").
      </p>

      <section className="terms-section">
        <h2>1. GENERAL PROVISIONS</h2>
        <p>
          <strong>1.1.</strong> Your use of the Service in any way and in any form (including, but not limited to: 
          visiting the website https://cyclingvirtualleague.com, registration, participation in tournaments) creates 
          an agreement on the terms of this Agreement.
        </p>
        <p>
          <strong>1.2.</strong> By using the Service, you confirm that you:
        </p>
        <ul>
          <li>have read the terms of this Agreement in full before starting to use it;</li>
          <li>accept all terms of this Agreement without any exceptions or limitations;</li>
          <li>undertake to comply with them or cease using the Service.</li>
        </ul>
        <p>
          <strong>1.3.</strong> The Administration reserves the right to make changes to this Agreement without 
          any special notice. The new version of the Agreement comes into force from the moment it is posted on 
          the Site https://cyclingvirtualleague.com. Continued use of the Service after making changes means your 
          agreement with them.
        </p>
      </section>

      <section className="terms-section">
        <h2>2. TERMS AND DEFINITIONS</h2>
        <p>
          <strong>2.1. Service (Platform)</strong> — a complex of software and hardware systems hosted on the 
          Internet at https://cyclingvirtualleague.com, which allows Users to:
        </p>
        <ul>
          <li>receive information about virtual cycling;</li>
          <li>register to participate in tournaments held on the Rouvy platform;</li>
          <li>track their results and the results of other participants;</li>
          <li>interact with other Users within the community.</li>
        </ul>
        <p>
          <strong>2.2. User</strong> — an individual who has completed the registration procedure on the Site 
          and has joined this Agreement.
        </p>
        <p>
          <strong>2.3. Rouvy</strong> — a third-party platform for virtual cycling (available at https://rouvy.com), 
          used to conduct competitions. The Administration is not a developer, representative, or affiliate of Rouvy.
        </p>
        <p>
          <strong>2.4. Tournament</strong> — a sports event organized by the Administration on Rouvy routes, 
          with a system for recording results and summarizing outcomes.
        </p>
        <p>
          <strong>2.5. User Content</strong> — any information uploaded by the User to the Service or transmitted 
          through it, including data, texts, images, comments.
        </p>
      </section>

      <section className="terms-section">
        <h2>3. REGISTRATION AND ACCOUNT</h2>
        <p>
          <strong>3.1.</strong> Use of the Service's functionality (participation in tournaments, access to 
          advanced statistics) is permitted only after the User has completed registration and authorization.
        </p>
        <p>
          <strong>3.2.</strong> When registering, the User undertakes to provide accurate and up-to-date information. 
          The Administration collects and processes the following identification data: login, email address, name 
          (optional), as well as data received from Rouvy as part of OAuth2 authorization (Rouvy user ID, race results).
        </p>
        <p>
          <strong>3.3.</strong> The User is fully responsible for the security of their authorization data (login, password) 
          and undertakes not to transfer them to third parties. The Administration is not liable for any damage resulting 
          from unauthorized access to the User's account.
        </p>
        <p>
          <strong>3.4.</strong> The User undertakes to use their real First and Last Name when registering and 
          participating in tournaments. The use of nicknames containing profanity or offensive expressions is prohibited.
        </p>
        <p>
          <strong>3.5.</strong> The Service may be used by persons aged 13 and over. To access certain health and 
          personal data-related features, the User must be at least 16 years old. If the User is younger than the 
          specified age, use of the Service is permitted only with the consent of a legal representative.
        </p>
      </section>

      <section className="terms-section">
        <h2>4. RIGHTS AND OBLIGATIONS OF THE PARTIES</h2>
        <p><strong>4.1. The User has the right to:</strong></p>
        <ul>
          <li>access the Service and participate in Tournaments under the terms of this Agreement;</li>
          <li>request information about their results;</li>
          <li>request deletion of their personal data by submitting a request to the Administration;</li>
          <li>deactivate their account at any time.</li>
        </ul>
        <p><strong>4.2. The User undertakes to:</strong></p>
        <ul>
          <li>comply with the rules for participating in Tournaments;</li>
          <li>not use the Service to post advertisements for third-party resources without coordination with the Administration;</li>
          <li>not publish materials promoting violence, extremism, discrimination, containing profanity or insults;</li>
          <li>not attempt to interfere with the Service's operation without authorization, not use automated tools 
            (robots, spiders) to access the Service;</li>
          <li>not violate the intellectual property rights of the Administration or third parties.</li>
        </ul>
        <p><strong>4.3. The Administration has the right to:</strong></p>
        <ul>
          <li>establish limits, rules, and regulations for conducting Tournaments;</li>
          <li>change the Service's functionality, add or remove features without prior notice;</li>
          <li>block, suspend, or delete a User's account in case of violation of this Agreement;</li>
          <li>delete any content posted by the User if it violates the terms of the Agreement.</li>
        </ul>
        <p><strong>4.4. The Administration undertakes to:</strong></p>
        <ul>
          <li>ensure the Service functions in accordance with its purpose;</li>
          <li>not transfer Users' personal data to third parties, except as provided by applicable law.</li>
        </ul>
      </section>

      <section className="terms-section">
        <h2>5. PARTICIPATION IN TOURNAMENTS</h2>
        <p>
          <strong>5.1.</strong> Participation in Tournaments conducted within the Service is voluntary.
        </p>
        <p>
          <strong>5.2.</strong> To participate in a Tournament, the User must:
        </p>
        <ul>
          <li>be registered on the cyclingvirtualleague.com website;</li>
          <li>have an active account on the Rouvy platform;</li>
          <li>complete the OAuth2 authorization procedure to provide the Service with access to necessary data (race results).</li>
        </ul>
        <p>
          <strong>5.3.</strong> The User may use third-party accounts (Rouvy) to register and log in to the Service. 
          In this case, the User grants the Administration consent to access data in such a third-party account in 
          accordance with privacy settings.
        </p>
        <p>
          <strong>5.4.</strong> The User confirms that participation in virtual cycling competitions requires a 
          certain level of physical fitness. The Administration is not liable for:
        </p>
        <ul>
          <li>any injuries or health deterioration received during training or participation in Tournaments;</li>
          <li>technical failures on the Rouvy platform side or the User's equipment.</li>
        </ul>
        <p>
          <strong>5.5.</strong> Tournament results are automatically recorded by the Rouvy platform. The Administration 
          calculates and publishes final results on the Site but does not guarantee the absolute accuracy of data 
          received from third-party platforms.
        </p>
      </section>

      <section className="terms-section">
        <h2>6. CONTENT AND INTELLECTUAL PROPERTY</h2>
        <p>
          <strong>6.1.</strong> Content posted on the Site (design, texts, "Cycling Virtual League" logo) is the 
          intellectual property of the Administration and is protected by copyright.
        </p>
        <p>
          <strong>6.2.</strong> The User retains all rights to content they upload to the Service. By posting content, 
          the User grants the Administration a free, non-exclusive license to use, reproduce, and display such content 
          in connection with the Service's operation.
        </p>
        <p>
          <strong>6.3.</strong> Use of content from the Site for commercial purposes without written consent from 
          the Administration is prohibited.
        </p>
        <p>
          <strong>6.4.</strong> The Cycling Virtual League Service has no affiliation, sponsorship, or connection 
          with third-party trademarks mentioned on the platform. Any use of names, trademarks, or logos is carried 
          out solely for informational purposes for identification.
        </p>
      </section>

      <section className="terms-section">
        <h2>7. DISCLAIMER OF WARRANTIES AND LIMITATION OF LIABILITY</h2>
        <p>
          <strong>7.1.</strong> The Service is provided on an "as-is" and "as available" basis. The Administration 
          does not guarantee uninterrupted operation of the Service or absence of errors.
        </p>
        <p>
          <strong>7.2.</strong> The Administration does not guarantee that information displayed in the Service 
          (especially received from third parties) will be complete, accurate, or up-to-date.
        </p>
        <p>
          <strong>7.3.</strong> Under no circumstances shall the Administration be liable for any direct, indirect, 
          or incidental damages arising from use or inability to use the Service.
        </p>
      </section>

      <section className="terms-section">
        <h2>8. ACCOUNT TERMINATION</h2>
        <p>
          <strong>8.1.</strong> The User may deactivate their account at any time through profile settings.
        </p>
        <p>
          <strong>8.2.</strong> Upon account deactivation, all User content may be deleted and access to the 
          Service terminated.
        </p>
        <p>
          <strong>8.3.</strong> The Administration may deactivate an account after prolonged inactivity (more than 
          24 months), notifying the User by email.
        </p>
      </section>

      <section className="terms-section">
        <h2>9. FINAL PROVISIONS</h2>
        <p>
          <strong>9.1.</strong> This Agreement comes into force for the User from the moment of registration on 
          the Site and is valid throughout the entire period of using the Service.
        </p>
        <p>
          <strong>9.2.</strong> The User agrees to receive informational and advertising messages from the 
          Administration related to the Service's operation. The User has the right to opt out of receiving 
          newsletters in profile settings.
        </p>
        <p>
          <strong>9.3.</strong> This Agreement is governed by the legislation of the place of the Administration's registration. All 
          disputes are subject to resolution in court at the location of the Administration's registration.
        </p>
      </section>
    </div>
  );

  const termsContentIt = (
    <div className="terms-content">
      <h1 className="terms-main-title">TERMINI DI SERVIZIO</h1>
      <p className="terms-date">Ultimo aggiornamento: 16 marzo 2026</p>

      <p className="terms-intro">
        Il presente documento «Termini di servizio» (di seguito «Accordo») costituisce un'offerta del team
        del sito Cycling Virtual League (di seguito «Amministrazione», «Noi») a concludere un accordo con
        qualsiasi persona fisica (di seguito «Utente», «Tu») alle condizioni indicate di seguito relative
        all'utilizzo del servizio Cycling Virtual League (di seguito «Servizio»).
      </p>

      <section className="terms-section">
        <h2>1. DISPOSIZIONI GENERALI</h2>
        <p>
          <strong>1.1.</strong> L'utilizzo del Servizio in qualsiasi modo e forma (inclusi, a titolo esemplificativo:
          la visita del sito https://cyclingvirtualleague.com, la registrazione, la partecipazione ai tornei) comporta
          la conclusione di un accordo alle condizioni del presente Accordo.
        </p>
        <p>
          <strong>1.2.</strong> Utilizzando il Servizio confermi di:
        </p>
        <ul>
          <li>aver letto integralmente le condizioni del presente Accordo prima di iniziare a utilizzarlo;</li>
          <li>accettare tutte le condizioni del presente Accordo senza eccezioni o limitazioni;</li>
          <li>impegnarti a rispettarle o a cessare l'utilizzo del Servizio.</li>
        </ul>
        <p>
          <strong>1.3.</strong> L'Amministrazione si riserva il diritto di modificare il presente Accordo senza
          alcun preavviso specifico. La nuova versione dell'Accordo entra in vigore dal momento della sua pubblicazione
          sul Sito https://cyclingvirtualleague.com. L'utilizzo continuato del Servizio dopo le modifiche implica
          l'accettazione delle stesse.
        </p>
      </section>

      <section className="terms-section">
        <h2>2. TERMINI E DEFINIZIONI</h2>
        <p>
          <strong>2.1. Servizio (Piattaforma)</strong> — un insieme di sistemi software e hardware ospitati in
          Internet all'indirizzo https://cyclingvirtualleague.com, che consente agli Utenti di:
        </p>
        <ul>
          <li>ricevere informazioni sul ciclismo virtuale;</li>
          <li>iscriversi per partecipare ai tornei che si svolgono sulla piattaforma Rouvy;</li>
          <li>seguire i propri risultati e quelli degli altri partecipanti;</li>
          <li>interagire con gli altri Utenti all'interno della community.</li>
        </ul>
        <p>
          <strong>2.2. Utente</strong> — persona fisica che ha completato la procedura di registrazione sul Sito
          e ha aderito al presente Accordo.
        </p>
        <p>
          <strong>2.3. Rouvy</strong> — piattaforma di terze parti per il ciclismo virtuale (disponibile all'indirizzo
          https://rouvy.com), utilizzata per lo svolgimento delle competizioni. L'Amministrazione non è sviluppatore,
          rappresentante o affiliato di Rouvy.
        </p>
        <p>
          <strong>2.4. Torneo</strong> — evento sportivo organizzato dall'Amministrazione sui percorsi Rouvy,
          con un sistema di registrazione dei risultati e di stesura delle classifiche.
        </p>
        <p>
          <strong>2.5. Contenuti dell'Utente (User Content)</strong> — qualsiasi informazione caricata dall'Utente
          nel Servizio o trasmessa tramite esso, inclusi dati, testi, immagini, commenti.
        </p>
      </section>

      <section className="terms-section">
        <h2>3. REGISTRAZIONE E ACCOUNT</h2>
        <p>
          <strong>3.1.</strong> L'utilizzo delle funzionalità del Servizio (partecipazione ai tornei, accesso alle
          statistiche avanzate) è consentito solo dopo che l'Utente ha completato la registrazione e l'autenticazione.
        </p>
        <p>
          <strong>3.2.</strong> Al momento della registrazione l'Utente si impegna a fornire informazioni veritiere
          e aggiornate. L'Amministrazione raccoglie e tratta i seguenti dati identificativi: login, indirizzo email,
          nome (facoltativo), nonché i dati ricevuti da Rouvy nell'ambito dell'autorizzazione OAuth2 (ID utente Rouvy,
          risultati delle gare).
        </p>
        <p>
          <strong>3.3.</strong> L'Utente è pienamente responsabile della sicurezza dei propri dati di accesso (login,
          password) e si impegna a non comunicarli a terzi. L'Amministrazione non è responsabile di eventuali danni
          derivanti da accessi non autorizzati all'account dell'Utente.
        </p>
        <p>
          <strong>3.4.</strong> L'Utente si impegna a utilizzare il proprio vero Nome e Cognome durante la registrazione
          e la partecipazione ai tornei. È vietato l'uso di nickname contenenti espressioni volgari od offensive.
        </p>
        <p>
          <strong>3.5.</strong> Il Servizio può essere utilizzato da persone che hanno compiuto 13 anni. Per accedere
          a determinate funzioni legate alla salute e ai dati personali, l'Utente deve avere almeno 16 anni. Se l'Utente
          non ha raggiunto l'età indicata, l'utilizzo del Servizio è consentito solo con il consenso di un rappresentante legale.
        </p>
      </section>

      <section className="terms-section">
        <h2>4. DIRITTI E OBBLIGHI DELLE PARTI</h2>
        <p><strong>4.1. L'Utente ha il diritto di:</strong></p>
        <ul>
          <li>accedere al Servizio e partecipare ai Tornei alle condizioni del presente Accordo;</li>
          <li>richiedere informazioni sui propri risultati;</li>
          <li>richiedere la cancellazione dei propri dati personali inviando una richiesta all'Amministrazione;</li>
          <li>disattivare il proprio account in qualsiasi momento.</li>
        </ul>
        <p><strong>4.2. L'Utente si impegna a:</strong></p>
        <ul>
          <li>rispettare le regole di partecipazione ai Tornei;</li>
          <li>non utilizzare il Servizio per pubblicizzare risorse di terzi senza l'accordo dell'Amministrazione;</li>
          <li>non pubblicare materiali che incitino alla violenza, all'estremismo o alla discriminazione, o che contengano
            linguaggio volgare o insulti;</li>
          <li>non tentare di interferire senza autorizzazione con il funzionamento del Servizio e non utilizzare strumenti
            automatizzati (robot, spider) per accedervi;</li>
          <li>non violare i diritti di proprietà intellettuale dell'Amministrazione o di terzi.</li>
        </ul>
        <p><strong>4.3. L'Amministrazione ha il diritto di:</strong></p>
        <ul>
          <li>stabilire limiti, regole e regolamenti per lo svolgimento dei Tornei;</li>
          <li>modificare le funzionalità del Servizio, aggiungere o rimuovere funzioni senza preavviso;</li>
          <li>bloccare, sospendere o eliminare l'account dell'Utente in caso di violazione del presente Accordo;</li>
          <li>eliminare qualsiasi contenuto pubblicato dall'Utente se viola le condizioni dell'Accordo.</li>
        </ul>
        <p><strong>4.4. L'Amministrazione si impegna a:</strong></p>
        <ul>
          <li>garantire il funzionamento del Servizio conformemente alla sua finalità;</li>
          <li>non trasferire a terzi i dati personali degli Utenti, salvo nei casi previsti dalla
            legislazione applicabile.</li>
        </ul>
      </section>

      <section className="terms-section">
        <h2>5. PARTECIPAZIONE AI TORNEI</h2>
        <p>
          <strong>5.1.</strong> La partecipazione ai Tornei organizzati nell'ambito del Servizio è volontaria.
        </p>
        <p>
          <strong>5.2.</strong> Per partecipare a un Torneo l'Utente deve:
        </p>
        <ul>
          <li>essere registrato sul sito cyclingvirtualleague.com;</li>
          <li>avere un account attivo sulla piattaforma Rouvy;</li>
          <li>completare la procedura di autorizzazione OAuth2 per consentire al Servizio l'accesso ai dati necessari
            (risultati delle gare).</li>
        </ul>
        <p>
          <strong>5.3.</strong> L'Utente può utilizzare account di terze parti (Rouvy) per registrarsi e accedere al
          Servizio. In tal caso l'Utente acconsente all'accesso dell'Amministrazione ai dati di tale account di terze
          parti in conformità con le impostazioni sulla privacy.
        </p>
        <p>
          <strong>5.4.</strong> L'Utente riconosce che la partecipazione a competizioni ciclistiche virtuali richiede
          un certo livello di preparazione fisica. L'Amministrazione non è responsabile di:
        </p>
        <ul>
          <li>eventuali infortuni o peggioramenti dello stato di salute occorsi durante l'allenamento o la partecipazione ai Tornei;</li>
          <li>malfunzionamenti tecnici della piattaforma Rouvy o dell'attrezzatura dell'Utente.</li>
        </ul>
        <p>
          <strong>5.5.</strong> I risultati dei Tornei sono registrati automaticamente dalla piattaforma Rouvy.
          L'Amministrazione calcola e pubblica le classifiche finali sul Sito, ma non garantisce l'assoluta accuratezza
          dei dati ricevuti da piattaforme di terze parti.
        </p>
      </section>

      <section className="terms-section">
        <h2>6. CONTENUTI E PROPRIETÀ INTELLETTUALE</h2>
        <p>
          <strong>6.1.</strong> I contenuti pubblicati sul Sito (design, testi, logo «Cycling Virtual League») sono
          proprietà intellettuale dell'Amministrazione e sono protetti dal diritto d'autore.
        </p>
        <p>
          <strong>6.2.</strong> L'Utente conserva tutti i diritti sui contenuti che carica nel Servizio. Pubblicando
          contenuti, l'Utente concede all'Amministrazione una licenza gratuita e non esclusiva per utilizzare, riprodurre
          e mostrare tali contenuti in relazione al funzionamento del Servizio.
        </p>
        <p>
          <strong>6.3.</strong> È vietato l'utilizzo dei contenuti del Sito a fini commerciali senza il consenso scritto
          dell'Amministrazione.
        </p>
        <p>
          <strong>6.4.</strong> Il Servizio Cycling Virtual League non ha affiliazioni, sponsorizzazioni o collegamenti
          con i marchi di terzi citati sulla piattaforma. Qualsiasi utilizzo di nomi, marchi o loghi avviene
          esclusivamente a scopo informativo e identificativo.
        </p>
      </section>

      <section className="terms-section">
        <h2>7. ESCLUSIONE DI GARANZIE E LIMITAZIONE DI RESPONSABILITÀ</h2>
        <p>
          <strong>7.1.</strong> Il Servizio è fornito «così com'è» (as-is) e «secondo disponibilità» (as available).
          L'Amministrazione non garantisce il funzionamento ininterrotto del Servizio né l'assenza di errori.
        </p>
        <p>
          <strong>7.2.</strong> L'Amministrazione non garantisce che le informazioni mostrate nel Servizio (in particolare
          quelle ricevute da terzi) siano complete, accurate o aggiornate.
        </p>
        <p>
          <strong>7.3.</strong> In nessun caso l'Amministrazione sarà responsabile di danni diretti, indiretti o
          incidentali derivanti dall'utilizzo o dall'impossibilità di utilizzare il Servizio.
        </p>
      </section>

      <section className="terms-section">
        <h2>8. CESSAZIONE DELL'ACCOUNT</h2>
        <p>
          <strong>8.1.</strong> L'Utente può disattivare il proprio account in qualsiasi momento dalle impostazioni del profilo.
        </p>
        <p>
          <strong>8.2.</strong> Alla disattivazione dell'account tutti i contenuti dell'Utente possono essere eliminati
          e l'accesso al Servizio interrotto.
        </p>
        <p>
          <strong>8.3.</strong> L'Amministrazione può disattivare un account in caso di inattività prolungata (oltre
          24 mesi), avvisando l'Utente via email.
        </p>
      </section>

      <section className="terms-section">
        <h2>9. DISPOSIZIONI FINALI</h2>
        <p>
          <strong>9.1.</strong> Il presente Accordo entra in vigore per l'Utente dal momento della registrazione sul
          Sito ed è valido per tutto il periodo di utilizzo del Servizio.
        </p>
        <p>
          <strong>9.2.</strong> L'Utente acconsente a ricevere dall'Amministrazione comunicazioni informative e
          promozionali relative al funzionamento del Servizio. L'Utente ha il diritto di rinunciare alla ricezione
          delle comunicazioni nelle impostazioni del profilo.
        </p>
        <p>
          <strong>9.3.</strong> Il presente Accordo è regolato dalla legislazione del luogo di registrazione dell'Amministrazione. Tutte le
          controversie sono di competenza del tribunale del luogo di registrazione dell'Amministrazione.
        </p>
      </section>
    </div>
  );

  const termsContentDe = (
    <div className="terms-content">
      <h1 className="terms-main-title">NUTZUNGSBEDINGUNGEN</h1>
      <p className="terms-date">Letzte Aktualisierung: 16. März 2026</p>

      <p className="terms-intro">
        Das vorliegende Dokument „Nutzungsbedingungen“ (im Folgenden „Vereinbarung“) stellt ein Angebot des Teams
        der Website Cycling Virtual League (im Folgenden „Administration“, „Wir“) dar, mit jeder natürlichen Person
        (im Folgenden „Nutzer“, „Du“) eine Vereinbarung zu den unten aufgeführten Bedingungen über die Nutzung
        des Dienstes Cycling Virtual League (im Folgenden „Dienst“) abzuschließen.
      </p>

      <section className="terms-section">
        <h2>1. ALLGEMEINE BESTIMMUNGEN</h2>
        <p>
          <strong>1.1.</strong> Die Nutzung des Dienstes in jeglicher Art und Form (insbesondere, aber nicht
          ausschließlich: der Besuch der Website https://cyclingvirtualleague.com, die Registrierung, die Teilnahme
          an Turnieren) bedeutet den Abschluss einer Vereinbarung zu den Bedingungen dieser Vereinbarung.
        </p>
        <p>
          <strong>1.2.</strong> Mit der Nutzung des Dienstes bestätigst du, dass du:
        </p>
        <ul>
          <li>die Bedingungen dieser Vereinbarung vor Beginn der Nutzung vollständig gelesen hast;</li>
          <li>alle Bedingungen dieser Vereinbarung ohne Ausnahmen oder Einschränkungen akzeptierst;</li>
          <li>dich verpflichtest, sie einzuhalten oder die Nutzung des Dienstes einzustellen.</li>
        </ul>
        <p>
          <strong>1.3.</strong> Die Administration behält sich das Recht vor, diese Vereinbarung ohne gesonderte
          Benachrichtigung zu ändern. Die neue Fassung der Vereinbarung tritt mit ihrer Veröffentlichung auf der
          Website https://cyclingvirtualleague.com in Kraft. Die weitere Nutzung des Dienstes nach den Änderungen
          gilt als Zustimmung zu diesen.
        </p>
      </section>

      <section className="terms-section">
        <h2>2. BEGRIFFE UND DEFINITIONEN</h2>
        <p>
          <strong>2.1. Dienst (Plattform)</strong> — eine Gesamtheit von Software- und Hardwaresystemen, die im
          Internet unter der Adresse https://cyclingvirtualleague.com bereitgestellt wird und es Nutzern ermöglicht:
        </p>
        <ul>
          <li>Informationen über virtuellen Radsport zu erhalten;</li>
          <li>sich für die Teilnahme an Turnieren auf der Plattform Rouvy anzumelden;</li>
          <li>die eigenen Ergebnisse und die der anderen Teilnehmer zu verfolgen;</li>
          <li>innerhalb der Community mit anderen Nutzern zu interagieren.</li>
        </ul>
        <p>
          <strong>2.2. Nutzer</strong> — eine natürliche Person, die die Registrierung auf der Website abgeschlossen
          hat und dieser Vereinbarung beigetreten ist.
        </p>
        <p>
          <strong>2.3. Rouvy</strong> — eine Drittanbieter-Plattform für virtuellen Radsport (erreichbar unter
          https://rouvy.com), die zur Durchführung der Wettbewerbe genutzt wird. Die Administration ist weder
          Entwickler noch Vertreter oder verbundenes Unternehmen von Rouvy.
        </p>
        <p>
          <strong>2.4. Turnier</strong> — eine von der Administration auf Rouvy-Strecken organisierte
          Sportveranstaltung mit einem System zur Erfassung der Ergebnisse und zur Erstellung von Wertungen.
        </p>
        <p>
          <strong>2.5. Nutzerinhalte (User Content)</strong> — alle Informationen, die der Nutzer in den Dienst
          hochlädt oder über ihn übermittelt, einschließlich Daten, Texten, Bildern und Kommentaren.
        </p>
      </section>

      <section className="terms-section">
        <h2>3. REGISTRIERUNG UND KONTO</h2>
        <p>
          <strong>3.1.</strong> Die Nutzung der Funktionen des Dienstes (Teilnahme an Turnieren, Zugriff auf
          erweiterte Statistiken) ist erst nach abgeschlossener Registrierung und Authentifizierung des Nutzers möglich.
        </p>
        <p>
          <strong>3.2.</strong> Bei der Registrierung verpflichtet sich der Nutzer, wahrheitsgemäße und aktuelle
          Angaben zu machen. Die Administration erhebt und verarbeitet folgende Identifikationsdaten: Login,
          E-Mail-Adresse, Name (optional) sowie die im Rahmen der OAuth2-Autorisierung von Rouvy erhaltenen Daten
          (Rouvy-Benutzer-ID, Rennergebnisse).
        </p>
        <p>
          <strong>3.3.</strong> Der Nutzer ist vollständig für die Sicherheit seiner Zugangsdaten (Login, Passwort)
          verantwortlich und verpflichtet sich, diese nicht an Dritte weiterzugeben. Die Administration haftet nicht
          für Schäden, die durch unbefugten Zugriff auf das Konto des Nutzers entstehen.
        </p>
        <p>
          <strong>3.4.</strong> Der Nutzer verpflichtet sich, bei der Registrierung und der Teilnahme an Turnieren
          seinen echten Vor- und Nachnamen zu verwenden. Nicknames mit vulgären oder beleidigenden Ausdrücken sind verboten.
        </p>
        <p>
          <strong>3.5.</strong> Der Dienst darf von Personen ab 13 Jahren genutzt werden. Für den Zugriff auf
          bestimmte Funktionen, die Gesundheits- und personenbezogene Daten betreffen, muss der Nutzer mindestens
          16 Jahre alt sein. Hat der Nutzer das angegebene Alter nicht erreicht, ist die Nutzung des Dienstes nur mit
          Zustimmung eines gesetzlichen Vertreters erlaubt.
        </p>
      </section>

      <section className="terms-section">
        <h2>4. RECHTE UND PFLICHTEN DER PARTEIEN</h2>
        <p><strong>4.1. Der Nutzer hat das Recht:</strong></p>
        <ul>
          <li>auf den Dienst zuzugreifen und zu den Bedingungen dieser Vereinbarung an Turnieren teilzunehmen;</li>
          <li>Informationen über seine Ergebnisse anzufordern;</li>
          <li>die Löschung seiner personenbezogenen Daten durch eine Anfrage an die Administration zu verlangen;</li>
          <li>sein Konto jederzeit zu deaktivieren.</li>
        </ul>
        <p><strong>4.2. Der Nutzer verpflichtet sich:</strong></p>
        <ul>
          <li>die Regeln für die Teilnahme an Turnieren einzuhalten;</li>
          <li>den Dienst nicht ohne Zustimmung der Administration zur Werbung für Angebote Dritter zu nutzen;</li>
          <li>keine Materialien zu veröffentlichen, die zu Gewalt, Extremismus oder Diskriminierung aufrufen oder
            vulgäre Sprache oder Beleidigungen enthalten;</li>
          <li>nicht unbefugt in den Betrieb des Dienstes einzugreifen und keine automatisierten Werkzeuge
            (Roboter, Spider) für den Zugriff darauf zu verwenden;</li>
          <li>keine geistigen Eigentumsrechte der Administration oder Dritter zu verletzen.</li>
        </ul>
        <p><strong>4.3. Die Administration hat das Recht:</strong></p>
        <ul>
          <li>Beschränkungen, Regeln und Reglements für die Durchführung von Turnieren festzulegen;</li>
          <li>die Funktionalität des Dienstes zu ändern sowie Funktionen ohne Vorankündigung hinzuzufügen oder zu entfernen;</li>
          <li>das Konto des Nutzers bei Verstößen gegen diese Vereinbarung zu sperren, auszusetzen oder zu löschen;</li>
          <li>vom Nutzer veröffentlichte Inhalte zu löschen, wenn sie gegen die Bedingungen der Vereinbarung verstoßen.</li>
        </ul>
        <p><strong>4.4. Die Administration verpflichtet sich:</strong></p>
        <ul>
          <li>den bestimmungsgemäßen Betrieb des Dienstes sicherzustellen;</li>
          <li>personenbezogene Daten der Nutzer nicht an Dritte weiterzugeben, außer in den vom
            anwendbaren Recht vorgesehenen Fällen.</li>
        </ul>
      </section>

      <section className="terms-section">
        <h2>5. TEILNAHME AN TURNIEREN</h2>
        <p>
          <strong>5.1.</strong> Die Teilnahme an den im Rahmen des Dienstes organisierten Turnieren ist freiwillig.
        </p>
        <p>
          <strong>5.2.</strong> Um an einem Turnier teilzunehmen, muss der Nutzer:
        </p>
        <ul>
          <li>auf der Website cyclingvirtualleague.com registriert sein;</li>
          <li>ein aktives Konto auf der Plattform Rouvy besitzen;</li>
          <li>die OAuth2-Autorisierung abschließen, damit der Dienst auf die erforderlichen Daten
            (Rennergebnisse) zugreifen kann.</li>
        </ul>
        <p>
          <strong>5.3.</strong> Der Nutzer kann Konten von Drittanbietern (Rouvy) zur Registrierung und Anmeldung beim
          Dienst verwenden. In diesem Fall stimmt der Nutzer zu, dass die Administration gemäß den
          Datenschutzeinstellungen auf die Daten dieses Drittanbieterkontos zugreift.
        </p>
        <p>
          <strong>5.4.</strong> Der Nutzer erkennt an, dass die Teilnahme an virtuellen Radrennen eine gewisse
          körperliche Fitness erfordert. Die Administration haftet nicht für:
        </p>
        <ul>
          <li>Verletzungen oder eine Verschlechterung des Gesundheitszustands während des Trainings oder der Teilnahme an Turnieren;</li>
          <li>technische Störungen der Plattform Rouvy oder der Ausrüstung des Nutzers.</li>
        </ul>
        <p>
          <strong>5.5.</strong> Die Ergebnisse der Turniere werden automatisch von der Plattform Rouvy erfasst.
          Die Administration berechnet und veröffentlicht die Endwertungen auf der Website, garantiert jedoch nicht
          die absolute Genauigkeit der von Drittanbieter-Plattformen erhaltenen Daten.
        </p>
      </section>

      <section className="terms-section">
        <h2>6. INHALTE UND GEISTIGES EIGENTUM</h2>
        <p>
          <strong>6.1.</strong> Die auf der Website veröffentlichten Inhalte (Design, Texte, Logo „Cycling Virtual
          League“) sind geistiges Eigentum der Administration und urheberrechtlich geschützt.
        </p>
        <p>
          <strong>6.2.</strong> Der Nutzer behält alle Rechte an den Inhalten, die er in den Dienst hochlädt. Mit der
          Veröffentlichung von Inhalten räumt der Nutzer der Administration eine unentgeltliche, nicht ausschließliche
          Lizenz ein, diese Inhalte im Zusammenhang mit dem Betrieb des Dienstes zu nutzen, zu vervielfältigen und anzuzeigen.
        </p>
        <p>
          <strong>6.3.</strong> Die Nutzung von Inhalten der Website zu kommerziellen Zwecken ist ohne schriftliche
          Zustimmung der Administration verboten.
        </p>
        <p>
          <strong>6.4.</strong> Der Dienst Cycling Virtual League ist mit den auf der Plattform genannten Marken
          Dritter weder verbunden noch wird er von ihnen gesponsert. Jede Verwendung von Namen, Marken oder Logos
          erfolgt ausschließlich zu Informations- und Identifikationszwecken.
        </p>
      </section>

      <section className="terms-section">
        <h2>7. GEWÄHRLEISTUNGSAUSSCHLUSS UND HAFTUNGSBESCHRÄNKUNG</h2>
        <p>
          <strong>7.1.</strong> Der Dienst wird „wie besehen“ (as-is) und „nach Verfügbarkeit“ (as available)
          bereitgestellt. Die Administration garantiert weder einen unterbrechungsfreien noch einen fehlerfreien
          Betrieb des Dienstes.
        </p>
        <p>
          <strong>7.2.</strong> Die Administration garantiert nicht, dass die im Dienst angezeigten Informationen
          (insbesondere von Dritten erhaltene) vollständig, genau oder aktuell sind.
        </p>
        <p>
          <strong>7.3.</strong> Die Administration haftet in keinem Fall für direkte, indirekte oder Folgeschäden,
          die aus der Nutzung oder der Unmöglichkeit der Nutzung des Dienstes entstehen.
        </p>
      </section>

      <section className="terms-section">
        <h2>8. BEENDIGUNG DES KONTOS</h2>
        <p>
          <strong>8.1.</strong> Der Nutzer kann sein Konto jederzeit in den Profileinstellungen deaktivieren.
        </p>
        <p>
          <strong>8.2.</strong> Bei der Deaktivierung des Kontos können alle Inhalte des Nutzers gelöscht und der
          Zugang zum Dienst beendet werden.
        </p>
        <p>
          <strong>8.3.</strong> Die Administration kann ein Konto bei längerer Inaktivität (mehr als 24 Monate)
          deaktivieren und den Nutzer darüber per E-Mail informieren.
        </p>
      </section>

      <section className="terms-section">
        <h2>9. SCHLUSSBESTIMMUNGEN</h2>
        <p>
          <strong>9.1.</strong> Diese Vereinbarung tritt für den Nutzer mit der Registrierung auf der Website in
          Kraft und gilt für den gesamten Zeitraum der Nutzung des Dienstes.
        </p>
        <p>
          <strong>9.2.</strong> Der Nutzer stimmt zu, von der Administration Informations- und Werbemitteilungen
          zum Betrieb des Dienstes zu erhalten. Der Nutzer kann den Empfang dieser Mitteilungen in den
          Profileinstellungen abbestellen.
        </p>
        <p>
          <strong>9.3.</strong> Diese Vereinbarung unterliegt dem Recht am Sitz der Administration. Für alle
          Streitigkeiten ist das Gericht am Sitz der Administration zuständig.
        </p>
      </section>
    </div>
  );

  const termsContentEs = (
    <div className="terms-content">
      <h1 className="terms-main-title">CONDICIONES DE USO</h1>
      <p className="terms-date">Última actualización: 16 de marzo de 2026</p>

      <p className="terms-intro">
        Este documento, «Condiciones de uso» (en adelante, el «Acuerdo»), constituye una oferta del equipo
        de Cycling Virtual League (en adelante, la «Administración», «Nosotros») de celebrar un contrato con
        cualquier persona física (en adelante, el «Usuario», «Usted») en los términos que se exponen a
        continuación, relativos al uso del servicio Cycling Virtual League (en adelante, el «Servicio»).
      </p>

      <section className="terms-section">
        <h2>1. DISPOSICIONES GENERALES</h2>
        <p>
          <strong>1.1.</strong> El uso del Servicio por su parte de cualquier manera y en cualquier forma
          (incluidos, entre otros: la visita al sitio https://cyclingvirtualleague.com, el registro y la
          participación en torneos) da lugar a un contrato en los términos del presente
          Acuerdo.
        </p>
        <p>
          <strong>1.2.</strong> Al utilizar el Servicio, usted confirma que:
        </p>
        <ul>
          <li>ha leído íntegramente las condiciones del presente Acuerdo antes de empezar a usarlo;</li>
          <li>acepta todas las condiciones del presente Acuerdo sin excepción ni limitación alguna;</li>
          <li>se compromete a cumplirlas o a dejar de utilizar el Servicio.</li>
        </ul>
        <p>
          <strong>1.3.</strong> La Administración se reserva el derecho a modificar el presente Acuerdo sin aviso
          especial alguno. La nueva versión del Acuerdo entra en vigor en el momento de su publicación en el sitio
          https://cyclingvirtualleague.com. Seguir utilizando el Servicio tras la modificación significa que usted
          la acepta.
        </p>
      </section>

      <section className="terms-section">
        <h2>2. TÉRMINOS Y DEFINICIONES</h2>
        <p>
          <strong>2.1. Servicio (Plataforma)</strong>: conjunto de sistemas de software y hardware alojados en
          internet en https://cyclingvirtualleague.com, que permite a los Usuarios:
        </p>
        <ul>
          <li>obtener información sobre el ciclismo virtual;</li>
          <li>inscribirse en los torneos que se celebran en la plataforma Rouvy;</li>
          <li>seguir sus resultados y los de los demás participantes;</li>
          <li>relacionarse con otros Usuarios dentro de la comunidad.</li>
        </ul>
        <p>
          <strong>2.2. Usuario</strong>: persona física que ha completado el procedimiento de registro en el sitio
          y se ha adherido al presente Acuerdo.
        </p>
        <p>
          <strong>2.3. Rouvy</strong>: plataforma de terceros para el ciclismo virtual (disponible en
          https://rouvy.com), empleada para celebrar las competiciones. La Administración no es desarrolladora,
          representante ni empresa vinculada de Rouvy.
        </p>
        <p>
          <strong>2.4. Torneo</strong>: evento deportivo organizado por la Administración sobre recorridos de
          Rouvy, con un sistema de registro de resultados y de elaboración de clasificaciones.
        </p>
        <p>
          <strong>2.5. Contenido del Usuario</strong>: cualquier información que el Usuario suba al Servicio o
          transmita a través de él, incluidos datos, textos, imágenes y comentarios.
        </p>
      </section>

      <section className="terms-section">
        <h2>3. REGISTRO Y CUENTA</h2>
        <p>
          <strong>3.1.</strong> El uso de las funciones del Servicio (participación en torneos, acceso a
          estadísticas avanzadas) solo se permite después de que el Usuario complete el registro y la
          autenticación.
        </p>
        <p>
          <strong>3.2.</strong> Al registrarse, el Usuario se compromete a facilitar información veraz y
          actualizada. La Administración recoge y trata los siguientes datos identificativos: nombre de acceso,
          dirección de correo electrónico, nombre (opcional), así como los datos recibidos de Rouvy en el marco de
          la autorización OAuth2 (identificador de usuario de Rouvy, resultados de carrera).
        </p>
        <p>
          <strong>3.3.</strong> El Usuario es plenamente responsable de la seguridad de sus datos de acceso
          (nombre de acceso, contraseña) y se compromete a no cederlos a terceros. La Administración no responde
          de los daños derivados de un acceso no autorizado a la cuenta del Usuario.
        </p>
        <p>
          <strong>3.4.</strong> El Usuario se compromete a utilizar su nombre y apellidos reales al registrarse y
          al participar en los torneos. Está prohibido el uso de apodos que contengan palabras malsonantes o
          expresiones ofensivas.
        </p>
        <p>
          <strong>3.5.</strong> El Servicio puede ser utilizado por personas de 13 años en adelante. Para acceder
          a determinadas funciones relacionadas con la salud y los datos personales, el Usuario debe tener al
          menos 16 años. Si el Usuario es menor de la edad indicada, el uso del Servicio solo se permite con el
          consentimiento de su representante legal.
        </p>
      </section>

      <section className="terms-section">
        <h2>4. DERECHOS Y OBLIGACIONES DE LAS PARTES</h2>
        <p><strong>4.1. El Usuario tiene derecho a:</strong></p>
        <ul>
          <li>acceder al Servicio y participar en los Torneos en los términos del presente Acuerdo;</li>
          <li>solicitar información sobre sus resultados;</li>
          <li>solicitar la supresión de sus datos personales dirigiendo una petición a la Administración;</li>
          <li>desactivar su cuenta en cualquier momento.</li>
        </ul>
        <p><strong>4.2. El Usuario se compromete a:</strong></p>
        <ul>
          <li>cumplir las normas de participación en los Torneos;</li>
          <li>no utilizar el Servicio para publicar anuncios de recursos ajenos sin acordarlo con la Administración;</li>
          <li>no publicar materiales que inciten a la violencia, el extremismo o la discriminación, ni que contengan palabras malsonantes o insultos;</li>
          <li>no intentar interferir sin autorización en el funcionamiento del Servicio ni utilizar herramientas
            automatizadas (robots, arañas) para acceder a él;</li>
          <li>no vulnerar los derechos de propiedad intelectual de la Administración ni de terceros.</li>
        </ul>
        <p><strong>4.3. La Administración tiene derecho a:</strong></p>
        <ul>
          <li>fijar límites, normas y reglamentos para la celebración de los Torneos;</li>
          <li>modificar las funciones del Servicio, añadir o retirar prestaciones sin aviso previo;</li>
          <li>bloquear, suspender o eliminar la cuenta de un Usuario en caso de incumplimiento del presente Acuerdo;</li>
          <li>eliminar cualquier contenido publicado por el Usuario si incumple las condiciones del Acuerdo.</li>
        </ul>
        <p><strong>4.4. La Administración se compromete a:</strong></p>
        <ul>
          <li>garantizar que el Servicio funcione conforme a su finalidad;</li>
          <li>no ceder los datos personales de los Usuarios a terceros, salvo en los casos previstos por la legislación aplicable.</li>
        </ul>
      </section>

      <section className="terms-section">
        <h2>5. PARTICIPACIÓN EN LOS TORNEOS</h2>
        <p>
          <strong>5.1.</strong> La participación en los Torneos que se celebran dentro del Servicio es voluntaria.
        </p>
        <p>
          <strong>5.2.</strong> Para participar en un Torneo, el Usuario debe:
        </p>
        <ul>
          <li>estar registrado en el sitio cyclingvirtualleague.com;</li>
          <li>tener una cuenta activa en la plataforma Rouvy;</li>
          <li>completar el procedimiento de autorización OAuth2 para dar al Servicio acceso a los datos necesarios (resultados de carrera).</li>
        </ul>
        <p>
          <strong>5.3.</strong> El Usuario puede emplear cuentas de terceros (Rouvy) para registrarse y acceder al
          Servicio. En ese caso, el Usuario autoriza a la Administración a acceder a los datos de esa cuenta de
          terceros conforme a sus ajustes de privacidad.
        </p>
        <p>
          <strong>5.4.</strong> El Usuario confirma que participar en competiciones de ciclismo virtual exige
          cierto nivel de forma física. La Administración no responde de:
        </p>
        <ul>
          <li>las lesiones o el empeoramiento de la salud sufridos durante los entrenamientos o la participación en los Torneos;</li>
          <li>los fallos técnicos de la plataforma Rouvy o del equipamiento del Usuario.</li>
        </ul>
        <p>
          <strong>5.5.</strong> Los resultados de los Torneos los registra automáticamente la plataforma Rouvy. La
          Administración calcula y publica los resultados finales en el sitio, pero no garantiza la exactitud
          absoluta de los datos recibidos de plataformas de terceros.
        </p>
      </section>

      <section className="terms-section">
        <h2>6. CONTENIDO Y PROPIEDAD INTELECTUAL</h2>
        <p>
          <strong>6.1.</strong> El contenido publicado en el sitio (diseño, textos, logotipo «Cycling Virtual
          League») es propiedad intelectual de la Administración y está protegido por los derechos de autor.
        </p>
        <p>
          <strong>6.2.</strong> El Usuario conserva todos los derechos sobre el contenido que sube al Servicio. Al
          publicarlo, el Usuario concede a la Administración una licencia gratuita y no exclusiva para usar,
          reproducir y mostrar dicho contenido en relación con el funcionamiento del Servicio.
        </p>
        <p>
          <strong>6.3.</strong> Está prohibido el uso del contenido del sitio con fines comerciales sin el
          consentimiento escrito de la Administración.
        </p>
        <p>
          <strong>6.4.</strong> El Servicio Cycling Virtual League no tiene vinculación, patrocinio ni relación
          con las marcas de terceros mencionadas en la plataforma. Cualquier uso de nombres, marcas o logotipos se
          realiza únicamente con fines informativos y de identificación.
        </p>
      </section>

      <section className="terms-section">
        <h2>7. EXCLUSIÓN DE GARANTÍAS Y LIMITACIÓN DE RESPONSABILIDAD</h2>
        <p>
          <strong>7.1.</strong> El Servicio se presta «tal cual» y «según disponibilidad». La Administración no
          garantiza el funcionamiento ininterrumpido del Servicio ni la ausencia de errores.
        </p>
        <p>
          <strong>7.2.</strong> La Administración no garantiza que la información mostrada en el Servicio (en
          especial la recibida de terceros) sea completa, exacta o esté actualizada.
        </p>
        <p>
          <strong>7.3.</strong> En ningún caso responderá la Administración de los daños directos, indirectos o
          accesorios derivados del uso o de la imposibilidad de uso del Servicio.
        </p>
      </section>

      <section className="terms-section">
        <h2>8. CIERRE DE LA CUENTA</h2>
        <p>
          <strong>8.1.</strong> El Usuario puede desactivar su cuenta en cualquier momento desde los ajustes del perfil.
        </p>
        <p>
          <strong>8.2.</strong> Al desactivarse la cuenta, todo el contenido del Usuario puede eliminarse y el
          acceso al Servicio darse por terminado.
        </p>
        <p>
          <strong>8.3.</strong> La Administración puede desactivar una cuenta tras un largo periodo de inactividad
          (más de 24 meses), avisando al Usuario por correo electrónico.
        </p>
      </section>

      <section className="terms-section">
        <h2>9. DISPOSICIONES FINALES</h2>
        <p>
          <strong>9.1.</strong> El presente Acuerdo entra en vigor para el Usuario desde el momento del registro en
          el sitio y es válido durante todo el periodo de uso del Servicio.
        </p>
        <p>
          <strong>9.2.</strong> El Usuario acepta recibir de la Administración comunicaciones informativas y
          publicitarias relacionadas con el funcionamiento del Servicio. El Usuario tiene derecho a darse de baja
          de esos envíos en los ajustes del perfil.
        </p>
        <p>
          <strong>9.3.</strong> El presente Acuerdo se rige por la legislación del lugar de registro de la Administración. Todos los
          litigios se resolverán ante el tribunal del lugar de registro de la Administración.
        </p>
      </section>
    </div>
  );

  const termsContentFr = (
    <div className="terms-content">
      <h1 className="terms-main-title">CONDITIONS D'UTILISATION</h1>
      <p className="terms-date">Dernière mise à jour : 16 mars 2026</p>

      <p className="terms-intro">
        Le présent document « Conditions d'utilisation » (ci-après le « Contrat ») constitue une offre de
        l'équipe de Cycling Virtual League (ci-après l'« Administration », « Nous ») de conclure un contrat avec
        toute personne physique (ci-après l'« Utilisateur », « Vous ») aux conditions énoncées ci-dessous,
        relatives à l'utilisation du service Cycling Virtual League (ci-après le « Service »).
      </p>

      <section className="terms-section">
        <h2>1. DISPOSITIONS GÉNÉRALES</h2>
        <p>
          <strong>1.1.</strong> Votre utilisation du Service, de quelque manière et sous quelque forme que ce soit
          (y compris, sans s'y limiter : la visite du site https://cyclingvirtualleague.com, l'inscription, la
          participation à des tournois), forme un contrat aux conditions du présent Contrat.
        </p>
        <p>
          <strong>1.2.</strong> En utilisant le Service, vous confirmez que :
        </p>
        <ul>
          <li>vous avez pris connaissance de l'intégralité des conditions du présent Contrat avant de commencer à l'utiliser ;</li>
          <li>vous acceptez toutes les conditions du présent Contrat, sans exception ni restriction ;</li>
          <li>vous vous engagez à les respecter ou à cesser d'utiliser le Service.</li>
        </ul>
        <p>
          <strong>1.3.</strong> L'Administration se réserve le droit de modifier le présent Contrat sans préavis
          particulier. La nouvelle version du Contrat entre en vigueur dès sa publication sur le site
          https://cyclingvirtualleague.com. La poursuite de l'utilisation du Service après la modification vaut
          acceptation de celle-ci.
        </p>
      </section>

      <section className="terms-section">
        <h2>2. TERMES ET DÉFINITIONS</h2>
        <p>
          <strong>2.1. Service (Plateforme)</strong> : ensemble de systèmes logiciels et matériels hébergés sur
          internet à l'adresse https://cyclingvirtualleague.com, qui permet aux Utilisateurs :
        </p>
        <ul>
          <li>de s'informer sur le cyclisme virtuel ;</li>
          <li>de s'inscrire aux tournois organisés sur la plateforme Rouvy ;</li>
          <li>de suivre leurs résultats et ceux des autres participants ;</li>
          <li>d'échanger avec les autres Utilisateurs au sein de la communauté.</li>
        </ul>
        <p>
          <strong>2.2. Utilisateur</strong> : personne physique ayant accompli la procédure d'inscription sur le
          site et ayant adhéré au présent Contrat.
        </p>
        <p>
          <strong>2.3. Rouvy</strong> : plateforme tierce de cyclisme virtuel (accessible à l'adresse
          https://rouvy.com), utilisée pour organiser les compétitions. L'Administration n'est ni le développeur,
          ni le représentant, ni une société affiliée de Rouvy.
        </p>
        <p>
          <strong>2.4. Tournoi</strong> : événement sportif organisé par l'Administration sur des parcours Rouvy,
          assorti d'un système d'enregistrement des résultats et d'établissement des classements.
        </p>
        <p>
          <strong>2.5. Contenu de l'Utilisateur</strong> : toute information téléversée par l'Utilisateur sur le
          Service ou transmise par son intermédiaire, y compris données, textes, images et commentaires.
        </p>
      </section>

      <section className="terms-section">
        <h2>3. INSCRIPTION ET COMPTE</h2>
        <p>
          <strong>3.1.</strong> L'utilisation des fonctionnalités du Service (participation aux tournois, accès aux
          statistiques avancées) n'est autorisée qu'après que l'Utilisateur a accompli l'inscription et
          l'authentification.
        </p>
        <p>
          <strong>3.2.</strong> Lors de l'inscription, l'Utilisateur s'engage à fournir des informations exactes et
          à jour. L'Administration collecte et traite les données d'identification suivantes : identifiant, adresse
          e-mail, nom (facultatif), ainsi que les données reçues de Rouvy dans le cadre de l'autorisation OAuth2
          (identifiant d'utilisateur Rouvy, résultats de course).
        </p>
        <p>
          <strong>3.3.</strong> L'Utilisateur est pleinement responsable de la sécurité de ses identifiants
          (identifiant, mot de passe) et s'engage à ne pas les communiquer à des tiers. L'Administration n'est pas
          responsable des dommages résultant d'un accès non autorisé au compte de l'Utilisateur.
        </p>
        <p>
          <strong>3.4.</strong> L'Utilisateur s'engage à utiliser ses véritables nom et prénom lors de
          l'inscription et de la participation aux tournois. L'usage de pseudonymes comportant des grossièretés ou
          des expressions injurieuses est interdit.
        </p>
        <p>
          <strong>3.5.</strong> Le Service peut être utilisé par les personnes âgées de 13 ans et plus. Pour
          accéder à certaines fonctionnalités liées à la santé et aux données personnelles, l'Utilisateur doit
          avoir au moins 16 ans. Si l'Utilisateur est plus jeune que l'âge indiqué, l'utilisation du Service n'est
          autorisée qu'avec l'accord de son représentant légal.
        </p>
      </section>

      <section className="terms-section">
        <h2>4. DROITS ET OBLIGATIONS DES PARTIES</h2>
        <p><strong>4.1. L'Utilisateur a le droit :</strong></p>
        <ul>
          <li>d'accéder au Service et de participer aux Tournois selon les conditions du présent Contrat ;</li>
          <li>de demander des informations sur ses résultats ;</li>
          <li>de demander la suppression de ses données personnelles en adressant une demande à l'Administration ;</li>
          <li>de désactiver son compte à tout moment.</li>
        </ul>
        <p><strong>4.2. L'Utilisateur s'engage :</strong></p>
        <ul>
          <li>à respecter les règles de participation aux Tournois ;</li>
          <li>à ne pas utiliser le Service pour publier des publicités de ressources tierces sans accord de l'Administration ;</li>
          <li>à ne pas publier de contenus incitant à la violence, à l'extrémisme ou à la discrimination, ni comportant de grossièretés ou d'injures ;</li>
          <li>à ne pas tenter de perturber sans autorisation le fonctionnement du Service et à ne pas recourir à des
            outils automatisés (robots, robots d'indexation) pour y accéder ;</li>
          <li>à ne pas porter atteinte aux droits de propriété intellectuelle de l'Administration ou de tiers.</li>
        </ul>
        <p><strong>4.3. L'Administration a le droit :</strong></p>
        <ul>
          <li>de fixer des limites, des règles et des règlements pour l'organisation des Tournois ;</li>
          <li>de modifier les fonctionnalités du Service, d'en ajouter ou d'en retirer sans préavis ;</li>
          <li>de bloquer, de suspendre ou de supprimer le compte d'un Utilisateur en cas de violation du présent Contrat ;</li>
          <li>de supprimer tout contenu publié par l'Utilisateur s'il enfreint les conditions du Contrat.</li>
        </ul>
        <p><strong>4.4. L'Administration s'engage :</strong></p>
        <ul>
          <li>à assurer le fonctionnement du Service conformément à sa destination ;</li>
          <li>à ne pas transmettre les données personnelles des Utilisateurs à des tiers, sauf dans les cas prévus par la législation applicable.</li>
        </ul>
      </section>

      <section className="terms-section">
        <h2>5. PARTICIPATION AUX TOURNOIS</h2>
        <p>
          <strong>5.1.</strong> La participation aux Tournois organisés au sein du Service est volontaire.
        </p>
        <p>
          <strong>5.2.</strong> Pour participer à un Tournoi, l'Utilisateur doit :
        </p>
        <ul>
          <li>être inscrit sur le site cyclingvirtualleague.com ;</li>
          <li>disposer d'un compte actif sur la plateforme Rouvy ;</li>
          <li>accomplir la procédure d'autorisation OAuth2 afin de donner au Service l'accès aux données nécessaires (résultats de course).</li>
        </ul>
        <p>
          <strong>5.3.</strong> L'Utilisateur peut utiliser des comptes tiers (Rouvy) pour s'inscrire et se
          connecter au Service. Dans ce cas, l'Utilisateur donne à l'Administration son accord pour accéder aux
          données de ce compte tiers conformément à ses paramètres de confidentialité.
        </p>
        <p>
          <strong>5.4.</strong> L'Utilisateur confirme que la participation à des compétitions de cyclisme virtuel
          exige un certain niveau de condition physique. L'Administration n'est pas responsable :
        </p>
        <ul>
          <li>des blessures ou de la dégradation de l'état de santé survenues pendant l'entraînement ou la participation aux Tournois ;</li>
          <li>des défaillances techniques de la plateforme Rouvy ou du matériel de l'Utilisateur.</li>
        </ul>
        <p>
          <strong>5.5.</strong> Les résultats des Tournois sont enregistrés automatiquement par la plateforme
          Rouvy. L'Administration calcule et publie les résultats définitifs sur le site, mais ne garantit pas
          l'exactitude absolue des données reçues de plateformes tierces.
        </p>
      </section>

      <section className="terms-section">
        <h2>6. CONTENU ET PROPRIÉTÉ INTELLECTUELLE</h2>
        <p>
          <strong>6.1.</strong> Le contenu publié sur le site (design, textes, logo « Cycling Virtual League ») est
          la propriété intellectuelle de l'Administration et est protégé par le droit d'auteur.
        </p>
        <p>
          <strong>6.2.</strong> L'Utilisateur conserve tous les droits sur le contenu qu'il téléverse sur le
          Service. En le publiant, l'Utilisateur accorde à l'Administration une licence gratuite et non exclusive
          d'utilisation, de reproduction et d'affichage de ce contenu dans le cadre du fonctionnement du Service.
        </p>
        <p>
          <strong>6.3.</strong> L'utilisation du contenu du site à des fins commerciales sans l'accord écrit de
          l'Administration est interdite.
        </p>
        <p>
          <strong>6.4.</strong> Le Service Cycling Virtual League n'a aucun lien d'affiliation, de parrainage ou de
          rattachement avec les marques de tiers mentionnées sur la plateforme. Tout usage de noms, de marques ou
          de logos est fait uniquement à titre informatif, à des fins d'identification.
        </p>
      </section>

      <section className="terms-section">
        <h2>7. EXCLUSION DE GARANTIES ET LIMITATION DE RESPONSABILITÉ</h2>
        <p>
          <strong>7.1.</strong> Le Service est fourni « en l'état » et « selon disponibilité ». L'Administration ne
          garantit ni le fonctionnement ininterrompu du Service, ni l'absence d'erreurs.
        </p>
        <p>
          <strong>7.2.</strong> L'Administration ne garantit pas que les informations affichées dans le Service
          (en particulier celles reçues de tiers) soient complètes, exactes ou à jour.
        </p>
        <p>
          <strong>7.3.</strong> L'Administration ne saurait en aucun cas être tenue responsable des dommages
          directs, indirects ou accessoires résultant de l'utilisation du Service ou de l'impossibilité de
          l'utiliser.
        </p>
      </section>

      <section className="terms-section">
        <h2>8. CLÔTURE DU COMPTE</h2>
        <p>
          <strong>8.1.</strong> L'Utilisateur peut désactiver son compte à tout moment depuis les réglages du profil.
        </p>
        <p>
          <strong>8.2.</strong> Lors de la désactivation du compte, l'ensemble du contenu de l'Utilisateur peut
          être supprimé et l'accès au Service interrompu.
        </p>
        <p>
          <strong>8.3.</strong> L'Administration peut désactiver un compte après une longue période d'inactivité
          (plus de 24 mois), en prévenant l'Utilisateur par e-mail.
        </p>
      </section>

      <section className="terms-section">
        <h2>9. DISPOSITIONS FINALES</h2>
        <p>
          <strong>9.1.</strong> Le présent Contrat entre en vigueur pour l'Utilisateur dès son inscription sur le
          site et reste valable pendant toute la durée d'utilisation du Service.
        </p>
        <p>
          <strong>9.2.</strong> L'Utilisateur accepte de recevoir de l'Administration des messages d'information et
          de publicité liés au fonctionnement du Service. L'Utilisateur peut se désabonner de ces envois dans les
          réglages du profil.
        </p>
        <p>
          <strong>9.3.</strong> Le présent Contrat est régi par la législation du lieu d'enregistrement de l'Administration. Tous les
          litiges relèvent du tribunal du lieu d'enregistrement de l'Administration.
        </p>
      </section>
    </div>
  );

  const termsContentCs = (
    <div className="terms-content">
      <h1 className="terms-main-title">PODMÍNKY POUŽITÍ</h1>
      <p className="terms-date">Poslední aktualizace: 16. března 2026</p>

      <p className="terms-intro">
        Tento dokument „Podmínky použití“ (dále jen „Smlouva“) je nabídkou týmu webu Cycling Virtual League
        (dále jen „Administrace“, „My“) uzavřít smlouvu s jakoukoli fyzickou osobou (dále jen „Uživatel“, „Vy“)
        za níže uvedených podmínek týkajících se používání služby Cycling Virtual League (dále jen „Služba“).
      </p>

      <section className="terms-section">
        <h2>1. OBECNÁ USTANOVENÍ</h2>
        <p>
          <strong>1.1.</strong> Používáním Služby jakýmkoli způsobem a v jakékoli formě (mimo jiné návštěvou
          webu https://cyclingvirtualleague.com, registrací, účastí v turnajích) vzniká smlouva za podmínek
          této Smlouvy.
        </p>
        <p>
          <strong>1.2.</strong> Používáním Služby potvrzujete, že:
        </p>
        <ul>
          <li>jste se před zahájením používání seznámili s podmínkami této Smlouvy v plném rozsahu;</li>
          <li>přijímáte všechny podmínky této Smlouvy bez jakýchkoli výjimek či omezení;</li>
          <li>se zavazujete je dodržovat, nebo Službu přestat používat.</li>
        </ul>
        <p>
          <strong>1.3.</strong> Administrace si vyhrazuje právo tuto Smlouvu měnit bez zvláštního upozornění.
          Nové znění Smlouvy nabývá účinnosti okamžikem zveřejnění na Webu https://cyclingvirtualleague.com.
          Pokračování v používání Služby po provedení změn znamená váš souhlas s nimi.
        </p>
      </section>

      <section className="terms-section">
        <h2>2. POJMY A DEFINICE</h2>
        <p>
          <strong>2.1. Služba (Platforma)</strong> — soubor softwarových a hardwarových prostředků umístěných
          na internetu na adrese https://cyclingvirtualleague.com, který Uživatelům umožňuje:
        </p>
        <ul>
          <li>získávat informace o virtuální cyklistice;</li>
          <li>registrovat se k účasti v turnajích pořádaných na platformě Rouvy;</li>
          <li>sledovat své výsledky a výsledky ostatních účastníků;</li>
          <li>komunikovat s ostatními Uživateli v rámci komunity.</li>
        </ul>
        <p>
          <strong>2.2. Uživatel</strong> — fyzická osoba, která dokončila registraci na Webu
          a přistoupila k této Smlouvě.
        </p>
        <p>
          <strong>2.3. Rouvy</strong> — platforma třetí strany pro virtuální cyklistiku (dostupná na https://rouvy.com),
          využívaná k pořádání soutěží. Administrace není vývojářem, zástupcem ani přidruženou osobou Rouvy.
        </p>
        <p>
          <strong>2.4. Turnaj</strong> — sportovní akce pořádaná Administrací na trasách Rouvy
          se systémem evidence výsledků a vyhodnocení.
        </p>
        <p>
          <strong>2.5. Uživatelský obsah</strong> — jakékoli informace, které Uživatel nahraje do Služby nebo jejím
          prostřednictvím předá, včetně dat, textů, obrázků a komentářů.
        </p>
      </section>

      <section className="terms-section">
        <h2>3. REGISTRACE A ÚČET</h2>
        <p>
          <strong>3.1.</strong> Používání funkcí Služby (účast v turnajích, přístup k rozšířeným statistikám)
          je povoleno pouze poté, co Uživatel dokončí registraci a přihlásí se.
        </p>
        <p>
          <strong>3.2.</strong> Při registraci se Uživatel zavazuje uvádět pravdivé a aktuální údaje.
          Administrace shromažďuje a zpracovává tyto identifikační údaje: přihlašovací jméno, e-mailovou adresu,
          jméno (nepovinné) a také údaje získané z Rouvy v rámci autorizace OAuth2 (ID uživatele Rouvy, výsledky závodů).
        </p>
        <p>
          <strong>3.3.</strong> Uživatel plně odpovídá za zabezpečení svých přihlašovacích údajů (přihlašovací jméno, heslo)
          a zavazuje se je nepředávat třetím osobám. Administrace neodpovídá za škody vzniklé
          neoprávněným přístupem k účtu Uživatele.
        </p>
        <p>
          <strong>3.4.</strong> Uživatel se zavazuje při registraci a účasti v turnajích používat své skutečné
          jméno a příjmení. Používání přezdívek obsahujících vulgarismy nebo urážlivé výrazy je zakázáno.
        </p>
        <p>
          <strong>3.5.</strong> Službu mohou používat osoby starší 13 let. Pro přístup k některým funkcím souvisejícím
          se zdravím a osobními údaji musí být Uživateli alespoň 16 let. Pokud je Uživatel mladší než
          uvedený věk, je používání Služby povoleno pouze se souhlasem zákonného zástupce.
        </p>
      </section>

      <section className="terms-section">
        <h2>4. PRÁVA A POVINNOSTI STRAN</h2>
        <p><strong>4.1. Uživatel má právo:</strong></p>
        <ul>
          <li>používat Službu a účastnit se Turnajů za podmínek této Smlouvy;</li>
          <li>vyžádat si informace o svých výsledcích;</li>
          <li>požádat o výmaz svých osobních údajů zasláním žádosti Administraci;</li>
          <li>kdykoli deaktivovat svůj účet.</li>
        </ul>
        <p><strong>4.2. Uživatel se zavazuje:</strong></p>
        <ul>
          <li>dodržovat pravidla účasti v Turnajích;</li>
          <li>nepoužívat Službu k umísťování reklamy na zdroje třetích stran bez souhlasu Administrace;</li>
          <li>nezveřejňovat materiály propagující násilí, extremismus či diskriminaci nebo obsahující vulgarismy či urážky;</li>
          <li>nepokoušet se neoprávněně zasahovat do fungování Služby a nepoužívat k přístupu ke Službě automatizované nástroje
            (roboty, crawlery);</li>
          <li>neporušovat práva duševního vlastnictví Administrace ani třetích osob.</li>
        </ul>
        <p><strong>4.3. Administrace má právo:</strong></p>
        <ul>
          <li>stanovovat limity, pravidla a předpisy pro pořádání Turnajů;</li>
          <li>měnit funkce Služby, přidávat nebo odebírat funkce bez předchozího upozornění;</li>
          <li>zablokovat, pozastavit nebo smazat účet Uživatele v případě porušení této Smlouvy;</li>
          <li>smazat jakýkoli obsah zveřejněný Uživatelem, pokud porušuje podmínky Smlouvy.</li>
        </ul>
        <p><strong>4.4. Administrace se zavazuje:</strong></p>
        <ul>
          <li>zajistit fungování Služby v souladu s jejím účelem;</li>
          <li>nepředávat osobní údaje Uživatelů třetím osobám s výjimkou případů stanovených platnými právními předpisy.</li>
        </ul>
      </section>

      <section className="terms-section">
        <h2>5. ÚČAST V TURNAJÍCH</h2>
        <p>
          <strong>5.1.</strong> Účast v Turnajích pořádaných v rámci Služby je dobrovolná.
        </p>
        <p>
          <strong>5.2.</strong> Pro účast v Turnaji musí Uživatel:
        </p>
        <ul>
          <li>být registrován na webu cyclingvirtualleague.com;</li>
          <li>mít aktivní účet na platformě Rouvy;</li>
          <li>dokončit autorizaci OAuth2 a poskytnout tak Službě přístup k potřebným údajům (výsledky závodů).</li>
        </ul>
        <p>
          <strong>5.3.</strong> Uživatel může k registraci a přihlášení do Služby používat účty třetích stran (Rouvy).
          V takovém případě Uživatel uděluje Administraci souhlas s přístupem k údajům v takovém účtu třetí strany
          v souladu s nastavením soukromí.
        </p>
        <p>
          <strong>5.4.</strong> Uživatel potvrzuje, že účast ve virtuálních cyklistických soutěžích vyžaduje
          určitou úroveň fyzické zdatnosti. Administrace neodpovídá za:
        </p>
        <ul>
          <li>jakákoli zranění nebo zhoršení zdravotního stavu vzniklá během tréninku nebo účasti v Turnajích;</li>
          <li>technické poruchy na straně platformy Rouvy nebo vybavení Uživatele.</li>
        </ul>
        <p>
          <strong>5.5.</strong> Výsledky Turnajů automaticky zaznamenává platforma Rouvy. Administrace
          vypočítává a zveřejňuje konečné výsledky na Webu, ale nezaručuje absolutní přesnost údajů
          získaných z platforem třetích stran.
        </p>
      </section>

      <section className="terms-section">
        <h2>6. OBSAH A DUŠEVNÍ VLASTNICTVÍ</h2>
        <p>
          <strong>6.1.</strong> Obsah zveřejněný na Webu (design, texty, logo „Cycling Virtual League“) je
          duševním vlastnictvím Administrace a je chráněn autorským právem.
        </p>
        <p>
          <strong>6.2.</strong> Uživateli zůstávají všechna práva k obsahu, který do Služby nahraje. Zveřejněním obsahu
          Uživatel uděluje Administraci bezúplatnou nevýhradní licenci k užití, rozmnožování a zobrazování takového obsahu
          v souvislosti s provozem Služby.
        </p>
        <p>
          <strong>6.3.</strong> Užití obsahu Webu pro komerční účely bez písemného souhlasu
          Administrace je zakázáno.
        </p>
        <p>
          <strong>6.4.</strong> Služba Cycling Virtual League není nijak spojena, sponzorována ani propojena
          s ochrannými známkami třetích stran uvedenými na platformě. Jakékoli užití názvů, ochranných známek
          nebo log slouží výhradně k informativním účelům a identifikaci.
        </p>
      </section>

      <section className="terms-section">
        <h2>7. VYLOUČENÍ ZÁRUK A OMEZENÍ ODPOVĚDNOSTI</h2>
        <p>
          <strong>7.1.</strong> Služba je poskytována „tak, jak je“ a „podle dostupnosti“. Administrace
          nezaručuje nepřetržitý provoz Služby ani absenci chyb.
        </p>
        <p>
          <strong>7.2.</strong> Administrace nezaručuje, že informace zobrazené ve Službě
          (zejména ty získané od třetích stran) budou úplné, přesné nebo aktuální.
        </p>
        <p>
          <strong>7.3.</strong> Administrace za žádných okolností neodpovídá za jakékoli přímé, nepřímé
          ani nahodilé škody vzniklé v důsledku používání nebo nemožnosti používání Služby.
        </p>
      </section>

      <section className="terms-section">
        <h2>8. UKONČENÍ ÚČTU</h2>
        <p>
          <strong>8.1.</strong> Uživatel může svůj účet kdykoli deaktivovat v nastavení profilu.
        </p>
        <p>
          <strong>8.2.</strong> Po deaktivaci účtu může být veškerý obsah Uživatele smazán a přístup
          ke Službě ukončen.
        </p>
        <p>
          <strong>8.3.</strong> Administrace může účet deaktivovat po dlouhodobé nečinnosti (déle než
          24 měsíců), o čemž Uživatele informuje e-mailem.
        </p>
      </section>

      <section className="terms-section">
        <h2>9. ZÁVĚREČNÁ USTANOVENÍ</h2>
        <p>
          <strong>9.1.</strong> Tato Smlouva nabývá pro Uživatele účinnosti okamžikem registrace na
          Webu a platí po celou dobu používání Služby.
        </p>
        <p>
          <strong>9.2.</strong> Uživatel souhlasí se zasíláním informačních a reklamních sdělení od
          Administrace souvisejících s provozem Služby. Uživatel má právo se z odběru těchto sdělení
          odhlásit v nastavení profilu.
        </p>
        <p>
          <strong>9.3.</strong> Tato Smlouva se řídí právním řádem místa registrace Administrace. Všechny
          spory podléhají rozhodnutí soudu v místě registrace Administrace.
        </p>
      </section>
    </div>
  );

  const termsContent = {
    ru: termsContentRu,
    it: termsContentIt,
    de: termsContentDe,
    es: termsContentEs,
    fr: termsContentFr,
    cs: termsContentCs,
  }[language] || termsContentEn;

  return (
    <div className="terms-container">
      <div className="terms-wrapper">
        {termsContent}
      </div>
    </div>
  );
};

export default Terms;